import React, { FC, ReactNode } from 'react';

import styled from '@emotion/styled';

import ImageWithPlaceholder, { ImageWithPlaceholderProps } from '../image/image-with-placeholder';

export interface CardImageProps extends ImageWithPlaceholderProps {
  /** The children to be rendered with the Card.Image. */
  children?: ReactNode;
}

const StyledCardImage: FC<CardImageProps> = styled(ImageWithPlaceholder)({
  label: 'cardImage',
  flex: '1 1 100%'
});

const CardImage: FC<CardImageProps> = ({ className, ...rest }) => (
  <StyledCardImage {...rest} className={className} />
);

export { CardImage };
export default CardImage;
